import { Dotsmenu } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { MenuItem } from '@mui/material'
import React, { useState } from 'react'
import ActionMenuButton from 'src/Elements/Buttons/ActionMenuButton'
import { TestRunRecord } from 'src/Libs/installation-details/models/hardware-tests.model'
import useModals from 'src/Hooks/useModals'

interface ListActionMenuProps {
  testRun: TestRunRecord
  onRunTask: (testRun: TestRunRecord) => void
  disableTestRun: boolean
}

/**
 * Provides functionality for each record in the hardware test runs table
 */
const ListActionMenu: React.FC<ListActionMenuProps> = ({ testRun, onRunTask, disableTestRun }) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null)
  const { t } = useCustomTranslation()
  const { openTestRunDetailsModal } = useModals()

  const onActionMenuClose = (): void => {
    setAnchorElement(null)
  }

  const onActionMenuOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorElement(event.currentTarget)
  }

  const renderMenuActions = (testRun: TestRunRecord): React.ReactElement[] => {
    return [
      <MenuItem
        key={'details'}
        onClick={() => {
          openTestRunDetailsModal({
            messageData: testRun.message,
            testId: testRun.testRunId,
            testDate: testRun.startedAt,
          })
          onActionMenuClose()
        }}
      >
        {t('system-details.hardware-test.test-run-details-dialog.details-button')}
      </MenuItem>,
      <MenuItem
        key={'rerun-task'}
        disabled={disableTestRun}
        onClick={() => {
          onActionMenuClose()
          onRunTask(testRun)
        }}
      >
        {t('system-details.hardware-tests.table.menu.rerun-task')}
      </MenuItem>,
    ]
  }

  return (
    <ActionMenuButton
      icon={<Dotsmenu />}
      actions={renderMenuActions(testRun)}
      anchorEl={anchorElement}
      handleClick={onActionMenuOpen}
      closeMenu={onActionMenuClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      disableScrollLock
    />
  )
}

export default ListActionMenu
